import { setMapRef } from 'app/actions/map';
import { MapFilterWindow, MapLeaflet, MapTaskWindow, MapTransportWindow } from 'app/pages/Map';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const Map = () => {
  const mapRef = useRef();
  const dispatch = useDispatch();
  const isTaskWindowVisible = useSelector((state) => !!state.map.taskSelectedItem);
  const isTransportWindowVisible = useSelector((state) => !!state.map.transportSelectedItem);

  useEffect(() => {
    dispatch(setMapRef(mapRef));
  }, [mapRef]);

  return (
    <React.Fragment>
      <MapFilterWindow />
      <MapLeaflet ref={mapRef} />
      {isTaskWindowVisible && <MapTaskWindow />}
      {isTransportWindowVisible && <MapTransportWindow />}
    </React.Fragment>
  );
};

export default Map;
